import React from 'react'
import { Stack, Typography, Button, useTheme } from '@mui/material'

const createStyles = (theme) => ({
  emptyState: {
    bgcolor: theme.palette.secondary.light,
    pt: '8.75rem',
    width: '100%',
    height: 'auto',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.secondary.dark}`,
  },
  icon: {
    fontSize: '40px',
    color: theme.palette.secondary.darker,
  },
  content: {
    my: 2,
    maxWidth: '880px',
  },
  heading: {
    color: theme.palette.text.primary,
  },
  description: {
    color: theme.palette.text.secondary,
    textAlign: 'center',
    '& .MuiLink-root': {
      color: `${theme.palette.primary.darker} !important`,
    },
  },
})

export const EmptyState = ({
  icon,
  heading,
  description,
  buttonText,
  onButtonClick,
  buttonVariant = 'contained',
  sx = {},
}) => {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Stack alignItems="center" sx={{ ...styles.emptyState, ...sx }}>
      {icon &&
        React.cloneElement(icon, {
          style: { ...styles.icon, ...icon.props?.style },
        })}
      <Stack alignItems="center" justifyContent="center" sx={styles.content}>
        {heading && (
          <Typography variant="h4" sx={styles.heading}>
            {heading}
          </Typography>
        )}
        {description && (
          <Typography variant="h5" sx={styles.description}>
            {description}
          </Typography>
        )}
      </Stack>
      {buttonText && onButtonClick && (
        <Button variant={buttonVariant} size="large" onClick={onButtonClick}>
          {buttonText}
        </Button>
      )}
    </Stack>
  )
}

export default EmptyState
